(function() {
  // Kolory tracków
  const TRACK_COLORS = {
    left: '#e0e0e0',    // szary - poza zakresem po lewej
    middle: '#00102f',   // granatowy - zaznaczony zakres
    right: '#e0e0e0'     // szary - poza zakresem po prawej
  };

  // Konfiguracja dla różnych typów sliderów
  const SLIDER_CONFIGS = {
    'diamond-proxy-colour-filter': {
      min: 0,
      max: 7,
      step: 1
    },
    'diamond-proxy-clarity-filter': {
      min: 0,
      max: 8,
      step: 1
    },
    'diamond-proxy-cut-filter': {
      min: 0,
      max: 4,
      step: 1
    },
    'diamond-proxy-price-filter': {
      isPrice: true,
      currency: 'zł'
    }
  };

  // Główna funkcja inicjalizacji
  function init() {
    console.log('Track Color Enhancer: Inicjalizacja...');
    
    // Dodaj globalne style CSS
    addGlobalStyles();
    
    // Znajdź i zainicjalizuj wszystkie slidery
    initAllSliders();
    
    // Uruchom obserwatora dla nowych sliderów
    startObserver();
    
    console.log('Track Color Enhancer: Zainicjalizowano');
  }

  // Dodaj globalne style CSS
  function addGlobalStyles() {
    const styleId = 'all-sliders-track-colors';
    if (document.getElementById(styleId)) return;
    
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      /* Kolorowanie tracków dla WSZYSTKICH sliderów */
      [data-track-colored="true"] [class*="track-0"],
      [data-track-colored="true"] [class*="track-2"],
      [data-track-colored="true"] [index="0"],
      [data-track-colored="true"] [index="2"] {
        background-color: #e0e0e0 !important;
        background: #e0e0e0 !important;
      }
      
      [data-track-colored="true"] [class*="track-1"],
      [data-track-colored="true"] [index="1"] {
        background-color: #00102f !important;
        background: #00102f !important;
      }
    `;
    document.head.appendChild(style);
    console.log('Track Color Enhancer: Dodano style CSS');
  }

  // Znajdź wszystkie kontenery sliderów
  function findAllSliderContainers() {
    const selectors = [
      '.diamond-proxy-colour-filter',
      '.diamond-proxy-clarity-filter', 
      '.diamond-proxy-cut-filter',
      '.diamond-proxy-price-filter'
    ];
    
    const containers = [];
    
    selectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(el => {
        // Sprawdź czy ma kontener tracków
        if (el.querySelector('.sc-gsJsQu')) {
          containers.push(el);
        }
      });
    });
    
    return containers;
  }

  // Inicjalizuj pojedynczy slider
  function initSlider(sliderContainer) {
    // Sprawdź czy już zinicjalizowano
    if (sliderContainer.dataset.trackColored === 'true') {
      return false;
    }

    console.log('Track Color Enhancer: Inicjalizuję slider', sliderContainer.className);

    // Znajdź kontener tracków
    const trackContainer = sliderContainer.querySelector('.sc-gsJsQu');
    if (!trackContainer) {
      console.log('Track Color Enhancer: Nie znaleziono kontenera tracków');
      return false;
    }

    // Znajdź tracki
    let tracks = findTracks(trackContainer);
    if (tracks.length < 3) {
      console.log('Track Color Enhancer: Znaleziono tylko', tracks.length, 'tracków');
      return false;
    }

    // Znajdź thumb'y
    const thumbs = findThumbs(trackContainer);
    
    // Oznacz jako zinicjalizowany
    sliderContainer.dataset.trackColored = 'true';
    
    // Sprawdź typ slidera
    const sliderType = getSliderType(sliderContainer);
    const config = SLIDER_CONFIGS[sliderType] || {};
    
    // Natychmiast zastosuj kolory
    applyTrackColors(tracks);
    
    // Dla slidera z ceną potrzebujemy specjalnej obsługi
    if (config.isPrice) {
      initPriceSlider(sliderContainer, tracks, thumbs);
    } else {
      // Standardowa obsługa dla innych sliderów
      initStandardSlider(sliderContainer, tracks, thumbs, config);
    }
    
    console.log('Track Color Enhancer: Slider', sliderType, 'zainicjalizowany pomyślnie');
    return true;
  }

  // Znajdź tracki
  function findTracks(trackContainer) {
    // Spróbuj różne metody
    let tracks = trackContainer.querySelectorAll('[class*="track"]');
    if (tracks.length >= 3) return tracks;
    
    tracks = trackContainer.querySelectorAll('[index]');
    if (tracks.length >= 3) return tracks;
    
    // Spróbuj znaleźć po klasie .sc-blIAwI
    tracks = trackContainer.querySelectorAll('.sc-blIAwI');
    return tracks;
  }

  // Znajdź thumb'y
  function findThumbs(trackContainer) {
    let thumbs = trackContainer.querySelectorAll('[class*="thumb"]');
    if (thumbs.length >= 2) return thumbs;
    
    thumbs = trackContainer.querySelectorAll('.sc-ibashp');
    return thumbs;
  }

  // Określ typ slidera
  function getSliderType(container) {
    for (const type in SLIDER_CONFIGS) {
      if (container.classList.contains(type)) {
        return type;
      }
    }
    return '';
  }

  // Zastosuj kolory do tracków
  function applyTrackColors(tracks) {
    if (!tracks || tracks.length < 3) return;
    
    // Używamy setTimeout aby zapewnić, że nasze style zostaną zastosowane po innych
    setTimeout(() => {
      // Track 0 - lewy (szary)
      if (tracks[0]) {
        tracks[0].style.setProperty('background-color', '#e0e0e0', 'important');
        tracks[0].style.setProperty('background', '#e0e0e0', 'important');
      }
      
      // Track 1 - środkowy (granatowy)
      if (tracks[1]) {
        tracks[1].style.setProperty('background-color', '#00102f', 'important');
        tracks[1].style.setProperty('background', '#00102f', 'important');
      }
      
      // Track 2 - prawy (szary)
      if (tracks[2]) {
        tracks[2].style.setProperty('background-color', '#e0e0e0', 'important');
        tracks[2].style.setProperty('background', '#e0e0e0', 'important');
      }
    }, 10);
  }

  // Inicjalizuj standardowy slider (kolor, czystość, szlif)
  function initStandardSlider(sliderContainer, tracks, thumbs, config) {
    // Dodaj obserwatora dla zmian w trackach
    addTrackObservers(tracks, sliderContainer);
    
    // Dodaj obserwatora dla thumb'ów
    if (thumbs.length >= 2) {
      addThumbObservers(thumbs, tracks, sliderContainer);
    }
    
    // Dodaj listenery dla inputów
    addInputListeners(sliderContainer, tracks);
    
    // Dodaj listener dla resize
    addResizeListener(sliderContainer, tracks);
  }

  // Inicjalizuj slider z ceną (specjalna obsługa)
  function initPriceSlider(sliderContainer, tracks, thumbs) {
    console.log('Track Color Enhancer: Inicjalizuję slider z ceną');
    
    // Znajdź inputy ceny
    const priceInputs = sliderContainer.querySelectorAll('input[type="text"]');
    if (priceInputs.length < 2) {
      console.log('Track Color Enhancer: Nie znaleziono inputów ceny');
      return;
    }
    
    // Dodaj obserwatora dla tracków
    addTrackObservers(tracks, sliderContainer);
    
    // Dodaj obserwatora dla thumb'ów
    if (thumbs.length >= 2) {
      addThumbObservers(thumbs, tracks, sliderContainer);
    }
    
    // Specjalne listenery dla inputów ceny
    addPriceInputListeners(priceInputs, tracks, sliderContainer);
    
    // Dodaj listener dla resize
    addResizeListener(sliderContainer, tracks);
    
    // Ręcznie zaktualizuj kolory po inicjalizacji
    setTimeout(() => {
      applyTrackColors(tracks);
    }, 100);
  }

  // Dodaj obserwatorów dla tracków
  function addTrackObservers(tracks, sliderContainer) {
    if (!sliderContainer._trackObservers) {
      sliderContainer._trackObservers = [];
    }
    
    tracks.forEach((track) => {
      const observer = new MutationObserver(() => {
        // Opóźnione zastosowanie kolorów
        setTimeout(() => {
          applyTrackColors(tracks);
        }, 10);
      });
      
      observer.observe(track, { 
        attributes: true, 
        attributeFilter: ['style'] 
      });
      
      sliderContainer._trackObservers.push(observer);
    });
  }

  // Dodaj obserwatorów dla thumb'ów
  function addThumbObservers(thumbs, tracks, sliderContainer) {
    if (!sliderContainer._thumbObservers) {
      sliderContainer._thumbObservers = [];
    }
    
    thumbs.forEach(thumb => {
      const observer = new MutationObserver(() => {
        setTimeout(() => {
          applyTrackColors(tracks);
        }, 10);
      });
      
      observer.observe(thumb, { 
        attributes: true, 
        attributeFilter: ['style'] 
      });
      
      sliderContainer._thumbObservers.push(observer);
    });
  }

  // Dodaj listenery dla standardowych inputów
  function addInputListeners(sliderContainer, tracks) {
    const inputs = sliderContainer.querySelectorAll('input[type="number"]');
    if (inputs.length === 0) return;
    
    if (!sliderContainer._inputListeners) {
      sliderContainer._inputListeners = [];
    }
    
    const handler = () => {
      setTimeout(() => {
        applyTrackColors(tracks);
      }, 50);
    };
    
    inputs.forEach(input => {
      input.addEventListener('input', handler);
      input.addEventListener('change', handler);
      sliderContainer._inputListeners.push({ input, handler });
    });
  }

  // Dodaj specjalne listenery dla inputów ceny
  function addPriceInputListeners(priceInputs, tracks, sliderContainer) {
    if (!sliderContainer._priceInputListeners) {
      sliderContainer._priceInputListeners = [];
    }
    
    const handler = () => {
      setTimeout(() => {
        applyTrackColors(tracks);
      }, 150); // Dłuższe opóźnienie dla ceny
    };
    
    priceInputs.forEach(input => {
      // Użyj różnych eventów dla inputów tekstowych
      input.addEventListener('input', handler);
      input.addEventListener('change', handler);
      input.addEventListener('blur', handler);
      
      sliderContainer._priceInputListeners.push({ input, handler });
    });
  }

  // Dodaj listener dla zmiany rozmiaru
  function addResizeListener(sliderContainer, tracks) {
    const handler = () => {
      setTimeout(() => {
        applyTrackColors(tracks);
      }, 250);
    };
    
    sliderContainer._resizeHandler = handler;
    window.addEventListener('resize', handler);
  }

  // Inicjalizuj wszystkie slidery
  function initAllSliders() {
    const sliderContainers = findAllSliderContainers();
    console.log('Track Color Enhancer: Znaleziono', sliderContainers.length, 'kontenerów sliderów');
    
    let initialized = 0;
    sliderContainers.forEach(container => {
      // Pomiń slider z karatami (ma już swój skrypt)
      if (container.classList.contains('diamond-proxy-carat-filter')) {
        return;
      }
      
      if (initSlider(container)) {
        initialized++;
      }
    });
    
    console.log('Track Color Enhancer: Zainicjalizowano', initialized, 'sliderów');
  }

  // Uruchom obserwatora dla nowych sliderów
  function startObserver() {
    // Jeśli już istnieje obserwator, nie tworz nowego
    if (window._trackColorObserver) {
      window._trackColorObserver.disconnect();
    }
    
    const observer = new MutationObserver((mutations) => {
      let shouldReinit = false;
      
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              // Sprawdź czy dodano element z klasą filtru
              const hasFilterClass = node.matches && (
                node.matches('.diamond-proxy-colour-filter, .diamond-proxy-clarity-filter, .diamond-proxy-cut-filter, .diamond-proxy-price-filter') || 
                node.querySelector('.diamond-proxy-colour-filter, .diamond-proxy-clarity-filter, .diamond-proxy-cut-filter, .diamond-proxy-price-filter')
              );
              
              if (hasFilterClass) {
                shouldReinit = true;
              }
            }
          });
        }
      });
      
      if (shouldReinit) {
        setTimeout(initAllSliders, 300);
      }
    });
    
    // Obserwuj kontener z filtrami
    const filterContainer = document.querySelector('.diamond-proxy-filter-parent-container');
    if (filterContainer) {
      observer.observe(filterContainer, {
        childList: true,
        subtree: true
      });
    } else {
      // Obserwuj body jako fallback
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
    
    window._trackColorObserver = observer;
  }

  // Czyszczenie
  function cleanupSlider(sliderContainer) {
    // Zatrzymaj obserwatorów tracków
    if (sliderContainer._trackObservers) {
      sliderContainer._trackObservers.forEach(observer => observer.disconnect());
    }
    
    // Zatrzymaj obserwatorów thumb'ów
    if (sliderContainer._thumbObservers) {
      sliderContainer._thumbObservers.forEach(observer => observer.disconnect());
    }
    
    // Usuń listenery standardowych inputów
    if (sliderContainer._inputListeners) {
      sliderContainer._inputListeners.forEach(({ input, handler }) => {
        input.removeEventListener('input', handler);
        input.removeEventListener('change', handler);
      });
    }
    
    // Usuń listenery inputów ceny
    if (sliderContainer._priceInputListeners) {
      sliderContainer._priceInputListeners.forEach(({ input, handler }) => {
        input.removeEventListener('input', handler);
        input.removeEventListener('change', handler);
        input.removeEventListener('blur', handler);
      });
    }
    
    // Usuń listener resize
    if (sliderContainer._resizeHandler) {
      window.removeEventListener('resize', sliderContainer._resizeHandler);
    }
  }

  // Ręczna reinicjalizacja
  window.reinitTrackColors = function() {
    console.log('Track Color Enhancer: Ręczna reinicjalizacja');
    
    // Wyczyść istniejące
    const existingContainers = document.querySelectorAll('[data-track-colored="true"]');
    existingContainers.forEach(cleanupSlider);
    
    // Usuń znaczniki
    existingContainers.forEach(container => {
      container.removeAttribute('data-track-colored');
    });
    
    // Ponowna inicjalizacja
    setTimeout(init, 100);
  };

  // Poczekaj na załadowanie DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // Daj czas na załadowanie dynamicznych elementów (szczególnie slidera ceny)
    setTimeout(init, 1500);
  }

  // Eksport funkcji dla debugowania
  window.trackColorEnhancer = {
    init,
    reinit: window.reinitTrackColors,
    cleanupSlider
  };
  
  console.log('Track Color Enhancer: Skrypt załadowany');
})();